import type { HorizontalAlignment } from '@api/generated/models';

export interface FlexibleBaseSpecification {
	id: number;
	order: number;
	horizontalAlignment: HorizontalAlignment;
}

export abstract class FlexibleModelBase {
	public readonly id: number;
	public readonly order: number;
	public readonly horizontalAlignment: HorizontalAlignment;

	constructor(spec: FlexibleBaseSpecification) {
		this.id = spec.id;
		this.order = spec.order;
		this.horizontalAlignment = spec.horizontalAlignment;
	}
}
